<template>
    <div class="container-fluid">
        <div class="row">
            <div class="container">
                <router-link to="/home"><img src="../../assets/arrow-back-pink.png" alt=""></router-link>&nbsp; Messages
             </div>
            <div class="col-sm-5 leftbar" style="height:auto">
                <div v-for="(r, index) in myprofile" :key="index">
                    <div class="chat" :id="'chat'+r.userid">
                        <span v-if="r.photo_url == NULL"  class="select-profile">
                            <img src="../../assets/user1.png" alt="" width="50px" height="50px" @click="select(r.userid)" style="margin-top:1px; margin-left:1px">
                        </span>
                        <span v-else class="select-profile">
                            <img :src="image_path + r.photo_url" alt="" width="50px" height="50px" @click="select(r.userid)" style="margin-top:1px; margin-left:1px">                                                            
                        </span>
                        <span @click="select(r.userid)">
                            <h4>&nbsp;{{ r.firstname }} {{ r.lastname }} <img src="../../assets/okay.png" alt="" width="12px"></h4>
                            <p>&nbsp;{{ r.relationship_goal }}</p>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-sm-7 rightbar" style="height:auto">
                <div v-if="isMessage">
                    <div class="chat-header">
                        <span v-if="user_info.photo_url == NULL" class="select-profile">
                            <img src="../../assets/user4.png" alt=""  width="60px" height="50px" style="margin-top:1px; margin-left:2px">
                        </span>
                        <span v-else class="select-profile">
                            <img :src="image_path + user_info.photo_url" alt="" width="60px" height="50px" style="margin-top:1px; margin-left:2px">                                                          
                        </span>
                        <span>
                            <h4> &nbsp;{{ user_info.firstname }} {{ user_info.lastname }} <img src="../../assets/okay.png" alt="" width="12px"></h4>
                            <p>&nbsp;{{ user_info.relationship_goal }} </p>
                        </span>
                    </div>
                    <div class="row" style="width:90%; margin-left:10px" v-for="(t, index) in chat_list" :key="index">
                        <span v-if="t.senderid == sender_id && t.receiverid == user_info.id">
                            <div class="chat-view-left">
                                <span class="select-profile">
                                    <img :src="image_path + user_photo" alt="" width="50px" height="50px" style="margin-top:1px; margin-left:2px; border-radius: 90px;">
                                </span>
                                <div class="message-date">
                                    <div class="message">
                                        <p> {{ t.messages }} </p>
                                    </div>
                                    <p class="date"></p>
                                </div>
                            </div>
                        </span>
                        <span v-if="t.receiverid == sender_id && t.senderid == user_info.id">
                            <div class="chat-view-right">
                                <div class="row message-date-right">
                                    <div class="col-sm-8 message-right">
                                        <p>{{ t.messages }}</p>
                                    </div>
                                    <div class="col-sm-4">
                                        <span class="select-profile">
                                            <img :src="image_path + user_info.photo_url" alt="" width="50px" height="50px" style="margin-top:1px; margin-left:2px;  border-radius: 90px;">
                                        </span>
                                    </div>
                                    <p class="date"> </p>
                                </div>
                            </div>
                        </span>
                    </div>
                    <div class="row" style="width:90%; margin-left:10px" v-for="(t, index) in chat_message" :key="index">
                        <span v-if="t.sender == sender_id && t.receiver == user_info.id">
                            <div class="chat-view-left">
                                <span class="select-profile">
                                    <img :src="image_path + user_photo" alt="" width="50px" height="50px" style="margin-top:1px; margin-left:2px; border-radius: 90px;">
                                </span>
                                <div class="message-date">
                                    <div class="message">
                                        <p> {{ t.message }} </p>
                                    </div>
                                    <p class="date"></p>
                                </div>
                            </div>
                        </span>
                        <span v-if="t.receiver == sender_id && t.sender == user_info.id">
                            <div class="chat-view-right">
                                <div class="row message-date-right">
                                    <div class="col-sm-8 message-right">
                                        <p>{{ t.message }}</p>
                                    </div>
                                    <div class="col-sm-4">
                                        <span class="select-profile">
                                            <img :src="image_path + user_info.photo_url" alt="" width="50px" height="50px" style="margin-top:1px; margin-left:2px;  border-radius: 90px;">
                                        </span>
                                    </div>
                                    <p class="date"> </p>
                                </div>
                            </div>
                        </span>
                    </div>
                    <div class="chat-input">
                        <input class="chat-input" type="text" placeholder="Type a message here..." v-model="message">
                    </div>
                    <span class="p-viewer">
                        <img src="../../assets/entypo_attachment.png" alt="" width="22px">&nbsp;
                        <button class="btn btn-info" @click="sendMessage()">Send</button>
                    </span>
                </div>
            </div>
        </div>
    </div>
    </template>
    <script>
    //import swal from 'sweetalert2';
    import Pusher from 'pusher-js';
    export default {
        components: {
         
        },
    
    data() {
      return {
    
        image_path: '',
        fullname: '',
        about: '',
        photo: '',
        myprofile: [],
        isMessage: false,
        chat_list: [],
        chat_listx: [],
        user_info: '',
        message: '',
        mychats: '',
        sender_id: '',
        user_photo: '',
        pusher: '',
        chat_message: [],
       
      };
    },
    
    beforeMount(){
       this.listAllConnections()
       //setInterval(this.listAllConnections(), 1000);
    },
    
    mounted(){
        Pusher.logToConsole = true;
      const pusher = new Pusher('5f390a45213d359d3c22', {
        cluster: 'eu'
      });
      const channel = pusher.subscribe('chat');
      channel.bind('message', data => {
        this.chat_message.push(data);
      });
    },
    
    methods: { 

        async listAllConnections(){
             try{
    
                const response = await this.$http.get('/my-connections-hangout', )
                this.myprofile = response.data.my_connections;
                this.image_path = response.data.image_path;
                          
                }catch (err) {
                        console.log(err);
                }
        },
    
        async select(e) {
            try{
                document.getElementById("chat"+e).classList.add('chatx');
                
            //this.filtering2 = true
            this.response = await this.$http.post('/display-chat', {
                receiverid: e,
            });
    
            //this.filtering2 = false
    
            if (!this.response.data.success) {
                // nothing
    
                } else {
                    
                    
                    this.chat_list = this.response.data.chat_list;  
                    this.user_photo = this.response.data.user_picture;  
                    this.user_info = this.response.data.user_info; 
                    this.sender_id = this.response.data.sender; 
                    this.image_path = this.response.data.image_path;
                    this.isMessage = true      
                    document.getElementById("chat"+e).classList.remove('chatx');   
                    this.message = ""
                        
    
            }
                                
            }catch (err) {
                console.log(err);
            }
    
        },
    
        async sendMessage() {
            try{
                         
            //this.filtering2 = true
            this.response = await this.$http.post('/send-chat', {
                message: this.message,
                receiverid: this.user_info.id,
            });
    
            //this.filtering2 = false
    
            if (!this.response.data.success) {
                // nothing
    
                } else { 
                        
                //this.select(this.user_info.id);
            }
                                
            }catch (err) {
                console.log(err);
            }
    
        },
    
      }
    }
    </script>
    <style lang="scss" scoped>
    .p-viewer {
        float: right;
        margin-top: -52px;
        margin-right: 18px;
        position: relative;
        z-index: 1;
        cursor:pointer;
        .btn-info {
            margin-top: -4px;
            border-radius: 25px;
            background: #242325;
            font-size: 10px;
        }
      }
    .container{
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 50px;
            width: 100%;
            margin-left: -30px;
            background: #D33E74;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 16px;
            line-height: 28px;
            text-align: center;
            color: #FFFFFF;
    
            img{
                width: 20px;
            }
     
        }
        .leftbar{
            margin-left: -30px;
            height: auto;
            background: #111112;
            border-right:1px solid #242325;
            overflow-y:scroll;
            .chat {
                display: flex;
                flex-direction: row;
                align-items: center;
                box-sizing: border-box;
                margin: 50px;
                margin-bottom: -30px;
                cursor: pointer;
    
                span > img {
                    //width: 70%;
                    border-radius: 43px;
                    margin: 10px;
                }
                span > h4 {
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 26px;
                    text-align: left;
                    color: #FFFFFF;
                }
                span > p {
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 10px;
                    text-align: left;
                    color: #767475;
                    margin-top: -8px;
                }

                .select-profile{
                    background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
                    border: 3px solid #D33E74;
                    border-radius: 97px;
                    width: 60px;
                    height: 60px;
                    display: block;
                   // margin-top: 5px;
                   // margin-bottom: 2px;
                }
            }
            .chatx {
                display: flex;
                flex-direction: row;
                align-items: center;
                box-sizing: border-box;
                margin: 50px;
                margin-bottom: -30px;
                background: #1C1C1D;
                border-right: 2px solid #D33E74;
                cursor: pointer;
    
                span > img {
                    width: 70%;
                    //padding-right: 1rem;
                }
                span > h4 {
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 26px;
                    text-align: left;
                    color: #FFFFFF;
                }
                span > p {
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 10px;
                    text-align: left;
                    color: #767475;
                    margin-top: -8px;
                }
            }
            
        }
        .rightbar{
            box-sizing: border-box;
            height: auto;
            background: #111112;
            //overflow-y:scroll;
            .chat-header {
    
                display: flex;
                flex-direction: row;
                align-items: center;
                box-sizing: border-box;
                margin: 50px;
                margin-bottom: 10px;
                cursor: pointer;
                border-bottom: 1px solid #312F33;
    
                span > img {
                    width: 80%;
                    border-radius: 43px;
                    //padding-right: 1rem;
                }
                span > h4 {
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 26px;
                    text-align: left;
                    color: #FFFFFF;
                }
                span > p {
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 10px;
                    text-align: left;
                    color: #767475;
                    margin-top: -8px;
                }

                .select-profile{
                    background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
                    border: 3px solid #D33E74;
                    border-radius: 97px;
                    width: 60px;
                    height: 60px;
                    display: block;
                    margin-top: 5px;
                   // margin-bottom: 2px;
                }
            }
            .chat-view-left {
    
                display: flex;
                flex-direction: row;
                align-items: center;
                box-sizing: border-box;
                margin-left: 0px;
                margin-top: 50px;
                cursor: pointer;
    
                .message-date{
                    margin-top: 30px;
                    width: 100%;
                    
                    .message {
                        margin-left: 25px;
                        background: #2F2F2F;
                        box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.02);
                        border-radius: 40px;
                        width: 55%;
                        height: auto;
                        padding-left: 1rem;
                        padding-top: 0rem;
                        //padding-bottom: 0.5rem;
                        padding-right: 1rem;
        
                      p {
                            margin-top: 10px;
                            font-family: 'Open Sans';
                            font-style: normal;
                            font-weight: 400;
                            font-size: 12px;
                            line-height: 19px;
                            color: #D9D9D9;
                            
                        }
                    }
                    .date{
                        flex-direction: column;
                        font-family: 'Open Sans';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 2px;
                        text-align: left;
                        color: #4F4F4F;
                    }
                }

                .select-profile{
                    background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
                    border: 3px solid #D33E74;
                    border-radius: 97px;
                    width: 60px;
                    height: 60px;
                    display: block;
                    margin-top: 5px;
                   // margin-bottom: 2px;
                }
                
            }
            .chat-view-right {
    
                margin-left: 50px;
                align-items: center;
                box-sizing: border-box;
                margin-top: 50px;
                cursor: pointer;
    
                .message-date-right{
                    margin-top: 0px;
                    margin-left: 20%;
                    align-items: center;
                    
                    .message-right {
                        background: #D33E74;
                        box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.02);
                        border-radius: 40px;
                        width: 55%;
                        height: auto;
                        //padding-top: 4.2rem;
        
                      p {
                            font-family: 'Open Sans';
                            font-style: normal;
                            font-weight: 400;
                            font-size: 12px;
                            line-height: 19px;
                            color: #D9D9D9;
                            
                        }
                    }
                    .date{
                        flex-direction: column;
                        font-family: 'Open Sans';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 16px;
                        text-align: left;
                        color: #4F4F4F;
                        margin-left: 40%;
                    }
                    .select-profile{
                        background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
                        border: 3px solid #D33E74;
                        border-radius: 97px;
                        width: 60px;
                        height: 60px;
                        display: block;
                        margin-top: 5px;
                       // margin-bottom: 2px;
                    }
                }
                
            }
    
        }
        .chat-input {
            width: 100%;
            height: 40px;
            background: #1C1C1D;
            border-radius: 61px;
            margin-bottom: 20px;
            font-family: 'Mulish';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 23px;
            text-align: left;
            color: #FFFFFF;
            padding-left: 10px;
    
        }
    
        @media screen and (max-width: 700px) {
            .container{
                display: flex;
                flex-direction: row;
                align-items: center;
                height: 50px;
                width: 94%;
                margin-left: 10px;
                background: #D33E74;
                border-top-right-radius: 8px;
                border-top-left-radius: 8px;
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 800;
                font-size: 16px;
                line-height: 28px;
                text-align: center;
                color: #FFFFFF;
        
                img{
                    width: 20px;
                }
         
            }
            .leftbar{
                width: 94%;
                margin-left: 10px;
                height: auto;
                background: #111112;
                border-bottom:1px solid #242325;
                overflow:scroll;
                
                .chat {
        
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    box-sizing: border-box;
                    margin: 50px;
                    margin-bottom: -30px;
        
                   
                    span > h4 {
                        font-family: 'DM Sans';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 16px;
                        line-height: 26px;
                        text-align: left;
                        color: #FFFFFF;
                    }
                    span > p {
                        font-family: 'DM Sans';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 10px;
                        text-align: left;
                        color: #767475;
                        margin-top: -8px;
                    }
                }
                
            }
    
            .rightbar{
                margin-top: 20px;
                width: 94%;
                margin-left: 10px;
                box-sizing: border-box;
                height: auto;
                background: #111112;
                overflow:scroll;
    
            .chat-header {
    
                display: flex;
                flex-direction: row; 
                align-items: center;
                box-sizing: border-box;
                margin: 50px;
                margin-bottom: -30px;
                cursor: pointer;
                border-bottom: 1px solid #312F33;
    
                
                span > h4 {
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 26px;
                    text-align: left;
                    color: #FFFFFF;
                }
                span > p {
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 10px;
                    text-align: left;
                    color: #767475;
                    margin-top: -8px;
                }
            }
            .chat-view-left {
                //width: 70%;
                display: flex;
                flex-direction: row;
                align-items: center;
                box-sizing: border-box;
                margin-left: 0px;
                margin-top: 50px;
                cursor: pointer;
    
             
                .message-date{
                    margin-top: 30px;
                    width: 100%;
                    
                    .message {
                        margin-left: 25px;
                        background: #2F2F2F;
                        box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.02);
                        border-radius: 40px;
                        width: auto;
                        height: auto;
                        padding-left: 1rem;
                        padding-top: 0rem;
                        padding-right: 1rem;
        
                      p {
                            margin-top: 10px;
                            font-family: 'Open Sans';
                            font-style: normal;
                            font-weight: 400;
                            font-size: 12px;
                            line-height: 19px;
                            color: #D9D9D9;
                            
                        }
                    }
                    .date{
                        flex-direction: column;
                        font-family: 'Open Sans';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 16px;
                        text-align: left;
                        color: #4F4F4F;
                    }
                }
                
            }
            .chat-view-right {
                display: flex;
                flex-direction: row;
                margin-left: 40px;
                align-items: center;
                box-sizing: border-box;
                margin-top: 50px;
                cursor: pointer;
    
               
                .message-date-right{
                    margin-top: 0px;
                    margin-left: 2%;
                    align-items: center;
                    
                    .message-right {
                        background: #D33E74;
                        box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.02);
                        border-radius: 40px;
                        width: 70%;
                        height: auto;
        
                      p {
                            font-family: 'Open Sans';
                            font-style: normal;
                            font-weight: 400;
                            font-size: 12px;
                            line-height: 13px;
                            color: #D9D9D9;
                            margin-top: 10px;
                            
                        }
                    }
                    .date{
                        flex-direction: column;
                        font-family: 'Open Sans';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 1px;
                        text-align: left;
                        color: #4F4F4F;
                        margin-left: 30%;
                    }
                }
                
            }
    
        }
        }
    </style>